// @flow
import { createSelector } from 'reselect';

const tripCriteriaSelector = ({ tripCriteria }) => tripCriteria || {};
const mainContactSelector = createSelector(
  tripCriteriaSelector,
  ({ mainContact }) => mainContact || {},
);

const getDepartureCity: (state: ReduxState) => ?string = createSelector(
  tripCriteriaSelector,
  ({ departureCity }) => departureCity,
);
const getDepartureDate: (state: ReduxState) => ?number = createSelector(
  tripCriteriaSelector,
  ({ departureDate }) => departureDate,
);
const getMainContactOptinEmail = createSelector(
  mainContactSelector,
  ({ optinEmail }) => optinEmail,
);
const getMainContactOptinSms = createSelector(mainContactSelector, ({ optinSms }) => optinSms);
const getMainContactOptinMail = createSelector(mainContactSelector, ({ optinMail }) => optinMail);
const getMainContactOptinPhone = createSelector(
  mainContactSelector,
  ({ optinPhone }) => optinPhone,
);
const getMainContactOptinFosun = createSelector(
  mainContactSelector,
  ({ optinFosun }) => optinFosun,
);
const getTripDuration: (state: ReduxState) => ?number = createSelector(
  tripCriteriaSelector,
  ({ duration }) => duration,
);

export {
  getDepartureCity,
  getDepartureDate,
  getMainContactOptinEmail,
  getMainContactOptinSms,
  getMainContactOptinFosun,
  getTripDuration,
  getMainContactOptinMail,
  getMainContactOptinPhone,
};
